import React, { Component } from "react";

import ProductPrice from "../../product/components/product-price";
import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';
import PurchaseButtonContainer from "../../product/components/purchase-button-container";
import { Helpers } from "../../core/src/helpers";

import "../css/compare.less";

class CompareModal extends Component {
  constructor(props) {
    super(props);
    this.state = { resultsArray: [] };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.compareResults.length > 0) {
      return CompareModal.updateCompareArray(props.compareResults);
    }
    return null;
  }

  componentDidUpdate(prevProps) {
    if (this.props.compareProducts.length < 2 && !prevProps.modalOpen) {
      prevProps.closeModal();
    }
  }

  static updateCompareArray(results) {
    let compareResults = [];
    results.forEach(spec => {
      let specTitles = [];
      let specValues = [];
      spec.specs.forEach((_, i) => {
        specTitles.push(
          <div className="compare-cell" key={i}>
            {spec.title}
          </div>
        );
      });
      spec.specs.forEach((pSpec, i) => {
        specValues.push(
          <div className="compare-cell" key={i}>
            {pSpec.value.constructor === Array
              ? pSpec.value.join(", ")
              : pSpec.value}
          </div>
        );
      });
      compareResults.push(specTitles);
      compareResults.push(specValues);
    });

    return { resultsArray: compareResults };
  }

  removeItem(product) {
    return () => {
      this.props.toggleCompareProduct(product);
    };
  }

  generateCompareList(showPrice) {
    let compareList = [];
    for (let i = 0; i < 4; i++) {
      let compareItem;
      if (this.props.compareProducts[i]) {
        let product = this.props.compareProducts[i];
        let [prdImage = {}] = product.images || [];
        let primaryImage = product.defaultImages ? prdImage.altImages[product.defaultImages - 1].lrg : prdImage.cdn;
        compareItem = (
          <div className="compare-item" key={i}>
            <button className="x-button unstyled" onClick={this.removeItem(product)} />
            <ImageWithPlaceholder
              src={Helpers.getCDNUrl(
                primaryImage,
                product.imageUrl,
                300
              )}
            />
            <div tabIndex={0} aria-label={product.name} className="compare-item-name">{product.name}</div>
            {showPrice && <ProductPrice product={product} />}
            {showPrice && <PurchaseButtonContainer product={product} />}
          </div>
        );
      } else {
        compareItem = (
          <div className="compare-item empty-item" key={i}>
            <div
              className="compare-no-item"
              onClick={showPrice ? () => this.props.closeModal() : null}
            >
              Add product to compare
            </div>
          </div>
        );
      }
      compareList[i] = compareItem;
    }
    return compareList;
  }

  render() {
    return (
      <div className="compare-modal-inner">
        <div className="compare-modal-title">Compare products</div>
        <div className="compare-table">
          <div className="compare-row">
            {this.generateCompareList(true).map((compareListItem, i) => {
              return (
                <div className="compare-cell" key={i}>
                  {compareListItem}
                </div>
              );
            })}
          </div>
          {this.state.resultsArray.map((row, i) => {
            return (
              <div className="compare-row" key={i}>
                {row}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default CompareModal;